import { render, staticRenderFns } from "./Invoice.vue?vue&type=template&id=063a4946&scoped=true&"
import script from "./Invoice.vue?vue&type=script&lang=js&"
export * from "./Invoice.vue?vue&type=script&lang=js&"
import style0 from "./Invoice.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Invoice.vue?vue&type=style&index=1&id=063a4946&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063a4946",
  null
  
)

export default component.exports